<div class="wrapper">
  <div class="action-section flex flex-row-reverse my-[20px] w-full gap-[20px]">
    <app-primary-button
      (handleClick)="create()"
      class="!w-[150px]"
      >
      Create
    </app-primary-button>
  </div>

  <div class="list-section">
    @if (dataSource?.length) {
      <div class="table-wrapper">
        <table [dataSource]="dataSource" class="mat-elevation-z8 table" mat-table>
          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th *matHeaderCellDef class="text-type-8" mat-header-cell>Name</th>
            <td *matCellDef="let row" mat-cell>
              <div class="text-type-11">{{ row?.name || row?.value }}</div>
            </td>
          </ng-container>
          <!-- Contacts Column -->
          <ng-container matColumnDef="contacts">
            <th *matHeaderCellDef class="text-type-8" mat-header-cell>Contacts</th>
            <td *matCellDef="let row" mat-cell>
              @if (row?.contacts?.length) {
                <div class="contacts-cell">
                  <div class="text-type-11">{{ row.contacts[0]?.name }}</div>
                  @if (row.contacts.length > 1) {
                    <div class="text-type-11 contacts-more">
                      +{{ row.contacts.length - 1 }} more
                    </div>
                  }
                </div>
              }
              @if (!row?.contacts?.length) {
                <div class="text-type-11">–</div>
              }
            </td>
          </ng-container>
          <!-- Phone Column -->
          <ng-container matColumnDef="phone">
            <th *matHeaderCellDef class="text-type-8" mat-header-cell>Phone</th>
            <td *matCellDef="let row" mat-cell>
              <div class="text-type-11">{{ row?.contacts?.[0]?.phone || row?.phone || '–' }}</div>
            </td>
          </ng-container>
          <!-- Email Column -->
          <ng-container matColumnDef="email">
            <th *matHeaderCellDef class="text-type-8" mat-header-cell>Email</th>
            <td *matCellDef="let row" mat-cell>
              <div class="text-type-11">{{ row?.contacts?.[0]?.email || row?.email || '–' }}</div>
            </td>
          </ng-container>
          <!-- Actions Column -->
          <ng-container matColumnDef="actions">
            <th *matHeaderCellDef mat-header-cell></th>
            <td *matCellDef="let row; let i = index" mat-cell (click)="$event.stopPropagation()">
              <button mat-icon-button [matMenuTriggerFor]="menu">
                <mat-icon>more_horiz</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="deleteItem(row, $event)">
                  <mat-icon svgIcon="trash"></mat-icon>
                  <span>Delete</span>
                </button>
              </mat-menu>
            </td>
          </ng-container>
          <!-- Header & Row Definitions -->
          <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
          <tr
            (click)="rowClicked(row)"
            *matRowDef="let row; columns: displayedColumns;"
            [class.highlighted-row]="row === selectedRow"
            class="cursor-pointer"
            mat-row
          ></tr>
        </table>
      </div>
    }

    <!-- No Data -->
    @if (!dataSource?.length) {
      <div class="no-data mt-[80px]">No data available.</div>
    }

    <!-- Paginator -->
    @if (totalRecords > 0) {
      <app-paginator
        (pageChanged)="onPageChanged($event)"
        [itemsPerPage]="pagination?.pageSize"
        [maxVisiblePages]="5"
        [totalItems]="totalRecords"
        class="paginator mt-[20px]"
        />
    }
  </div>
</div>
